// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__-VEXv","footer":"Form_footer__3RC4D"};